import React, { useEffect, useState } from 'react'
import { useAuth } from '../../../firebase/AuthProvider';
import { Conversation, getConversationById } from '../../../services/chatService/ChatService';
import { toast } from 'react-toastify';
import ChatWindow from '../realtimeChatComponents/ChatWindow';
import { GetorCreateConversationForEventAsync } from '../../../services/videoService/VideoService';
import { ValidateOtpResponseDto } from '../../../interfaces/ExtermalUserDtos/ExternalUsersDtos';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface VideoChatWindowProps {
    messagesOpen: boolean;
    conversationId?: number;
    calendarEventId?: string;
    externalUserDetails?: ValidateOtpResponseDto | null
    onClose?: () => void;
}

const VideoChatWindow: React.FC<VideoChatWindowProps> = ({
    conversationId,
    messagesOpen,
    calendarEventId,
    externalUserDetails,
    onClose
}) => {
    const { currentUser } = useAuth();
    const [conversation, setConversations] = useState<Conversation>();
    const [authToken, setAuthToken] = useState<string>();
    useEffect(() => {
        console.log("Hey i am in VideoChatWindow");
        
        const fetchdata = async () => {
            const token = currentUser ? await currentUser.getIdToken() : "";
            setAuthToken(token);
            if (conversationId) {
                GetConversationById(conversationId, token);
            } else if (calendarEventId) {
                CreateOrGetConversationOnEventId(calendarEventId, token);
            }
        }
        fetchdata();
    }, []);

    // For conversation Id
    const GetConversationById = (conversationId: number, token: string) => {
        getConversationById(token, conversationId).then((res) => {
            if (res) {
                setConversations(res);
            }
        }).catch((err) => {
            toast.error(err.message);
        })
    }

    // For CalenderEventUd
    const CreateOrGetConversationOnEventId = (calendarEventId: string, token: string) => {
        GetorCreateConversationForEventAsync(token, calendarEventId).then((res) => {
            if (res.success) {
                setConversations(res.data);
            } else {
                toast.error(res.message);
            }
        }).catch((err) => {
            toast.error(err.message);
        })
    }   

    return (
        <div className='d-flex flex-column h-100 bg-white'>
            <div className="d-flex justify-content-between align-items-center p-3 text-black" style={{ flexShrink: 0 }}>
                <h5 className="mb-0 text-black">Chat</h5>
                {onClose && (
                    <button className="btn btn-link text-black d-lg-none" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} size="lg" color='#000'/>
                    </button>
                )}
            </div>
            <div className='video_confrence_chat_msg text-gray-700 flex-grow-1' style={{ display: messagesOpen ? 'block' : 'none', overflowY: 'auto' }}>
                {
                    conversation && (currentUser || externalUserDetails) &&
                    <ChatWindow
                        // authToken={authToken}
                        // currentUserId={currentUser.uid}
                        conversation={conversation}
                        singlePane={false}
                        isShowCallingIcon={false}
                        externalUserDetails={externalUserDetails}
                        scrollToBottomTrigger={messagesOpen}
                    />
                }
            </div>
        </div>
    )
}

export default VideoChatWindow